import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const getGrxListPayload = ({ type, data }) => {
  const { storyNo, msidViewed } = data;
  const payload = {};
  let grxobj = {};
  if (type === 'view') {
    grxobj = {
      index_y: storyNo,
      msid_view: msidViewed,
    };
  } else {
    grxobj = {
      index_y: storyNo,
      msid_click: msidViewed,
      success_type: '_click',
    };
  }
  payload.slot_name = 'homepage_feed';
  payload.body = JSON.stringify(grxobj);
  return payload;
};
export const triggerGrxListView = data => {
  const payload = getGrxListPayload({ type: 'view', data });
  if (typeof grx === 'function') {
    analyticsWrapper('grx', 'track', 'Edit_MSID_View', payload);
  } else {
    const grxQueueObject = {
      eventName: 'Edit_MSID_View',
      payload,
    };
    window.Times.setGRXDataInLocalStorage('GRX_QUEUE', grxQueueObject);
  }
};
export const triggerGrxListClick = data => {
  const payload = getGrxListPayload({ data });
  const grxQueueObject = {
    eventName: 'Edit_MSID_Click',
    payload,
  };
  window.Times.setGRXDataInLocalStorage('GRX_QUEUE', grxQueueObject);
};
